// extracted by mini-css-extract-plugin
export default {"input":"datePicker_input__56KyO","label":"datePicker_label__rw+de"};